import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "6ef6fd19-d7db-4f53-ac76-a6bdcc98f14c",
    content: "0.01 Pa, i.e., -61 dB without absorption and<br>0.00000003 Pa, i.e., -147 dB accounting for absorption.",
    options: {},
  },
  {
    id: "4c6be8cb-5ac1-4bcc-94a2-4b2df8078a37",
    content: "0.002 Pa, i.e., -62 dB without absorption and<br>0.00000006 Pa, i.e., -145 dB accounting for absorption.",
    options: {},
  },
  {
    id: "bd4f275a-d9c6-4bc9-a032-83d195b85a08",
    content: "0.001 Pa, i.e., -60 dB without absorption and<br>0.00000004 Pa, i.e., -147 dB accounting for absorption.",
    options: {},
  },
  {
    id: "3b1eaeee-5055-439b-8e52-b15913d5982e",
    content: "0.002 Pa, i.e., -60 dB without absorption and<br>0.00000003 Pa, i.e., -147 dB accounting for absorption.",
    options: {},
  },
];

export const task: Task = {
  id: "0fcc4709-9ffc-43f4-aa6f-364021637233",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["bd4f275a-d9c6-4bc9-a032-83d195b85a08"],
};
